import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import RoomDetails from "../../ReservationSegmentCard/tabs/RoomDetails";
import ServiceLogBuilderErrors from "../ServiceLogBuilderErrors";
import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import TimePickerInput from '../../TimePickerInput/TimePickerInput';
import { isSameDay } from 'date-fns';

class ServiceLogBuilderGeneral extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'service-log-general',
      'tab-pane': true
    })

    if (this.props.reservation_segment) {
      var check_in_date = DateHelper.parseDate(this.props.reservation_segment.check_in_date)
      var today = DateHelper.current()

      var check_in_today = isSameDay( new Date(this.props.reservation_segment.check_in_date), new Date()) && this.props.reservation_segment.status != "checked_in"
      var check_out_today = isSameDay( new Date(this.props.reservation_segment.check_out_date), new Date()) && this.props.reservation_segment.status == "checked_in"
    }

    return(
      <div className={tabClasses} id="service_requests">
        {this.props.errors ? this.renderErrors(this.props.errors) : null}
        <div>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>{`${I18n.t('scheduled')}*`}</label>
                  <br />
                  <div>
                    <DatePickerInput 
                      classNames={this.renderFieldClasses('scheduled_at')} 
                      selectedDate={this.props.service_log.scheduled_at ? this.props.service_log.scheduled_at : ''}
                      onChange={this.props.onChangeScheduledAt} 
                      dateFormat={this.props.date_format} 
                    /> 
                    <a className="time-expand" onClick={this.props.onChangeSetTimeOpen}>{I18n.t('set_time')} {this.props.service_log.setTimeOpen ? <span className="toggle-arrow arrow-down"></span> : <span className="toggle-arrow arrow-right"></span>} </a>
                  </div>
                  {this.renderFieldErrors('scheduled_at')}

                  <div className="row col-sm-qw">
                    {
                    this.props.service_log.setTimeOpen
                    ?
                    <>
                      <div className="col-sm-6">
                        <label>{I18n.t('between')}</label>
                        <br />
                        <TimePickerInput
                          format={this.props.time_format}
                          selectedTime={this.props.service_log.startTime ? this.props.service_log.startTime : null}
                          onChange={this.props.onChangeStartTime}/>
                      </div>

                      <div className="col-sm-6" >
                        <label>{I18n.t('and')}</label>

                        <TimePickerInput
                          format={this.props.time_format}
                          selectedTime={this.props.service_log.endTime ? this.props.service_log.endTime : null}
                          onChange={this.props.onChangeEndTime} />
                      </div>
                    </>
                    :
                    null
                    }
                  </div>
                </div>
              </div>
              <div className="col-sm-4 form-group">
                <label>{I18n.t('status')}</label>
                <br />
                <select defaultValue={this.props.service_log.status} className="form-control" onChange={this.props.onChangeStatus}>
                  <option value="submitted">{I18n.t('submitted')}</option>
                  <option value="acknowledged">{I18n.t('acknowledged')}</option>
                  <option value="started">{I18n.t('started')}</option>
                  <option value="finished">{I18n.t('finished')}</option>
                  <option value="missed">{I18n.t('missed')}</option>
                  <option value="canceled">{I18n.t('canceled')}</option>
                </select>
              </div>

            </div>
            <hr />
          <div className="row">

            <div className="col-sm-4 form-group">
                <label>{`${I18n.t('service_request_description')}`}</label>
                <br />
                <div>
                  <textarea  defaultValue={this.props.service_log.description || ""} rows="3" className={this.renderFieldClasses('description')} onChange={this.props.onChangeTextInput}></textarea>
                </div>
                {this.renderFieldErrors('description')}
            </div>
            {
              this.props.service_log.products && this.props.service_log.products.length > 0
                ?
                <div className="col-sm-4 form-group">
                  <label>{`${I18n.t('product_description')}`}</label>
                  <br />
                  <div>{this.props.service_log.products[0].description}</div>
                  {this.renderFieldErrors('assigned_to_id')}
                </div>

                :
              null
            }
          </div>
          <hr className="hr" />
          <div className="row">
            {!this.props.new_record && this.props.reservation_segment
              ?
              <RoomDetails {...this.props} check_in_date={check_in_date} today={today} check_in_today={check_in_today} check_out_today={check_out_today} read_only={true} />
              :
              null
            }
          </div>
        </div>
     </div>
    )
  }

  renderErrors() {
    var errors = ServiceLogBuilderErrors.general(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        if(error == "Scheduled At can't be blank") {
          error =  ` ${I18n.t("scheduled")} ${I18n.t('cant_be_blank')}`
        }
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, noFormControl) {
    if(noFormControl == true) {
      var classname = ''
    } else {
      var classname = 'form-control'
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    } else {
      classname = classname + " no error"
    }
    return classname
  }

}

export default ServiceLogBuilderGeneral